var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglepay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4553 8.17784C15.4553 7.63341 15.4115 7.08898 15.3239 6.55566H7.8877V9.63336H12.1479C11.9727 10.6222 11.4032 11.5111 10.5708 12.0666V14.0666H13.1116C14.601 12.6777 15.4553 10.6222 15.4553 8.17784Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88785 16.0002C10.0125 16.0002 11.8085 15.2891 13.1118 14.0669L10.571 12.067C9.85915 12.5558 8.95016 12.8336 7.88785 12.8336C5.82894 12.8336 4.08763 11.4225 3.46339 9.53369H0.845947V11.6003C2.18205 14.3002 4.909 16.0002 7.88785 16.0002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46401 9.53371C3.13541 8.54485 3.13541 7.4671 3.46401 6.46712V4.41162H0.846149C-0.28205 6.66712 -0.28205 9.33372 0.846149 11.5892L3.46401 9.53371Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88785 3.16707C9.01587 3.14485 10.1001 3.57817 10.9105 4.36704L13.1665 2.07821C11.7319 0.722687 9.84819 -0.0217381 7.88785 0.000483554C4.909 0.000483554 2.18205 1.71155 0.845947 4.41148L3.46339 6.4781C4.08763 4.57814 5.82894 3.16707 7.88785 3.16707Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepay);
export default __webpack_public_path__ + "static/media/googlepay.5b08aa89ef5d0a55b8d5d9c73acca8d1.svg";
export { ForwardRef as ReactComponent };